import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageLoaderComponent } from './image-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileSaverDirective } from 'ngx-filesaver';

@NgModule({
    imports: [MatProgressSpinnerModule, CommonModule, FileSaverDirective],
    declarations: [ImageLoaderComponent],
    exports: [ImageLoaderComponent],
    providers: []
})
export class ImageLoaderModule {}
